import React, { useState, useEffect, useCallback } from 'react';
import { 
    Typography, Button, Paper, TextField, IconButton, Box, Dialog,
    DialogTitle, DialogContent
} from '@mui/material';
import Grid from '@mui/material/Grid2';
import { myApi } from '../../config/axiosConfig';
import useMediaQuery from '@mui/material/useMediaQuery';
import Swal from 'sweetalert2';
import BtnAcciones from '../../components/plantilla/tabla/BtnAcciones';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { useRef } from "react";
import { AllCommunityModule } from 'ag-grid-community'; // ✅ Importación de módulos
import { AgGridReact } from 'ag-grid-react';
import img from "../../assets/img/spinner.svg";

// Iconos
import AddCircleIcon from '@mui/icons-material/AddCircle';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import DeleteIcon from '@mui/icons-material/Delete';
import ClearIcon from '@mui/icons-material/Clear';
import CollectionsIcon from '@mui/icons-material/Collections';

import CrearEditarModal from './modales/CrearEditarGasoMax';
import GalleryDialog from './modales/GalleryDialog';
import Draggable from 'react-draggable';

function PaperComponent(props) {
    const nodeRef = React.useRef(null);
    return (
      <Draggable
        nodeRef={nodeRef}
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} ref={nodeRef} />
      </Draggable>
    );
}

const CargasGasoMax = () => {
    const gridRef = useRef();
    const isNonMobile = useMediaQuery("(min-width:600px)");

    const [data, setData] = useState([]);
    const [selected, setSelected] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [isEditing, setIsEditing] = useState(false);

    const [loading, setLoading] = useState(false);

    const [unit, setUnit] = useState('');
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const [open, setOpen] = useState(false);
    const [fileUrl, setFileUrl] = useState('');
    const [isPdf, setIsPdf] = useState(false);
    const [isImage, setIsImage] = useState(false);
    const [Titulo, setTitulo] = useState('');

    const handleChangeUnidad = (event) => setUnit(event.target.value);

    const handleChangeStartDate = (newValue) => {
        setStartDate(newValue);
        if (endDate && newValue.isAfter(endDate)) {
            Swal.fire({
                icon: 'error',
                title: 'La fecha inicial no puede ser mayor que la fecha final.',
            }).then(() => setEndDate(newValue)); 
        }
    };

    const handleChangeEndDate = (newValue) => {
        setEndDate(newValue);
        if (startDate && newValue.isBefore(startDate)) {
            Swal.fire({
                icon: 'error',
                title: 'La fecha final no puede ser menor que la fecha inicial.',
            }).then(() => setEndDate(startDate)); 
        }
    };

    const handleClearDate = (fecha) => {
        if(fecha === 'fi') setStartDate(null); 
        else if (fecha === 'ff') setEndDate(null); 
    };

    const normalizarFotosGrid = (fotos) => {
        if (!fotos) return [];
        let parsed = fotos;
        if (typeof fotos === 'string') {
            try { parsed = JSON.parse(fotos); } catch { return []; }
        }
        if (!Array.isArray(parsed)) parsed = [parsed];
        return parsed.filter(f => f && typeof f === 'object' && typeof f.ruta === 'string' && f.ruta.trim() !== '');
    };

    const [selectedRow, setSelectedRow] = useState(null);
    const [openGallery, setOpenGallery] = useState(false);

    const handleCloseGallery = () => {
        setOpenGallery(false);
        setSelectedRow(null);
    };

    const renderizarDialogGaleria = (row) => {
        let rutas = [];
        try {
            rutas = typeof row.fotos === 'string' ? JSON.parse(row.fotos) : row.fotos;
        } catch (e) {
            console.warn("No se pudo convertir rutas_fotos a array:", e);
            rutas = [];
        }

        if (!Array.isArray(rutas)) rutas = [rutas];

        const rutasValidas = rutas.filter(f =>
            f && typeof f === 'object' && typeof f.ruta === 'string' && f.ruta.trim() !== ''
        );

        if (rutasValidas.length === 0) {
            Swal.fire("Sin imágenes", "Esta unidad no tiene imágenes disponibles.", "info");
            return;
        }

        setSelectedRow({ ...row, rutas_fotos: rutasValidas });
        setOpenGallery(true);
    }; 

    const handleFileClick = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();
        const isPdfFile = extension === 'pdf';
        const isImageFile = ['jpg', 'jpeg', 'png', 'gif'].includes(extension);
        const mimeType = isPdfFile ? 'application/pdf' : isImageFile ? `image/${extension === 'jpg' ? 'jpeg' : extension}` : '';

        myApi.get(`fuel_report/pdf/${encodeURIComponent(fileName)}`, { responseType: 'arraybuffer' })
        .then((response) => {
            const blob = new Blob([response.data], { type: mimeType });
            const url = window.URL.createObjectURL(blob);
            setIsPdf(isPdfFile);
            setIsImage(isImageFile);
            setFileUrl(url);
            setOpen(true);
        })
        .catch((error) => { console.error('Error al cargar el PDF:', error); });
    };

    const handleOpenDialog = (params, isPdf = 1, nombre_col = '', titulo = '') => {
        setTitulo(titulo);
        if(isPdf) handleFileClick(params.pdf);
    };

    const handleCloseDialog = () => setOpen(false);

    const handleOpenModal = (carga = null) => {
        setSelected(carga);
        setIsEditing(!!carga);
        setModalOpen(true);
    };

    const handleDelete = useCallback(async (id) => {
        try {
            Swal.fire({
                title: '¿Estás seguro de eliminar esta carga?',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: 'green',
                cancelButtonColor: 'red',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let { data } = await myApi.delete(`/cargasFuel/deleteGasoMax/${id}`);
                    if (data.success) {
                        Swal.fire({ icon: 'success', title: 'Carga eliminada' });
                        setData(prevData => prevData.filter(carga => carga.id !== id));
                    } else {
                        Swal.fire({ icon: 'error', title: 'Error al eliminar la carga' });
                    }
                }
            });
        } catch (error) {
            console.error('Error deleting fuel up:', error);
        }
    }, []);

    const handleEdit = useCallback(async (fuelRow) => {
        handleOpenModal(data.find(carga => carga.id === fuelRow.id));
        setIsEditing(true);
        setSelected(fuelRow);
    }, [data]);

    const formatDate = (date) => {
        if (!date) return ""; 
        const d = new Date(date);
        if (isNaN(d)) return "";

        const options = {
            year: '2-digit', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false,
        };
    
        const formattedDate = new Date(date).toLocaleString('en-US', options);
        const [datePart, timePart] = formattedDate.split(', ');
        const [month, day, year] = datePart.split('/');
        return `${month}/${day}/${year} ${timePart}`;
    };

    const columns = [
        {
            headerName: "PDF", headerTooltip: "PDF", width: 50, field: "pdf",
            filter: false, suppressMenu: true, suppressColumnsToolPanel: true,
            cellStyle: { textAlign: "center" }, pinned: true,
            cellRenderer: (params) => {
                const row = params.data;
                if(row && row.pdf) {
                    return (
                        <Box>
                            <BtnAcciones icon={<PictureAsPdfIcon />} label={'Abrir PDF'} onClick={() => handleOpenDialog(row, 1, null, 'PDF SUBIDO')} />
                        </Box>
                    );
                }
            }
        },
        {
            field: "fotos", headerName: "IMÁGENES", headerTooltip: "IMÁGENES", width: 50,
            filter: false, pinned: true,
            cellRenderer: (params) => {
                const fotosValidas = normalizarFotosGrid(params.data?.fotos);
                if (fotosValidas.length === 0) return null;
                return (
                    <BtnAcciones
                        icon={<CollectionsIcon />} label={`Ver (${fotosValidas.length})`}
                        onClick={() => renderizarDialogGaleria({ ...params.data, fotos: fotosValidas })}
                    />
                );
            }
        },
        { field: 'fecha', headerName: 'FECHA', valueFormatter: (params) => formatDate(params.value), pinned: true },
        { field: 'noEconomico', headerName: 'UNIDAD', pinned: true },
        { field: 'grupo', headerName: 'GRUPO' },
        { field: 'cliente', headerName: 'CLIENTE' },
        {
            field: 'consumoPesos', headerName: 'CONSUMO PESOS',
            valueFormatter: (params) => Number(params.value || 0).toLocaleString('en-US', { style: 'currency', currency: 'USD' }),
        },
        {
            field: 'consumoLitros', headerName: 'CONSUMO LITROS',
            valueFormatter: (params) => Number(params.value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
        },
        { field: 'producto', headerName: 'PRODUCTO' },
        { field: 'orden', headerName: 'ORDEN' },
        { field: 'ubicacion', headerName: 'UBICACIÓN' },
        { field: 'destino', headerName: 'DESTINO' },
        { field: 'nivelDiesel', headerName: 'NIVEL DIÉSEL' },
        {
            field: 'actions', headerName: 'ACCIONES',
            cellRenderer: (params) => {
                if (params.data?.isTotal) return null;
                return (
                    <Box display="flex" gap={1}>
                        <IconButton color="primary" onClick={() => handleEdit(params.data)}>
                            <BorderColorIcon />
                        </IconButton>
                        <IconButton color="error" onClick={() => handleDelete(params.data.id)}>
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                );
            }
        }
    ];

    const fetch = async (unidad = null, fi = null, ff = null) => {
        setLoading(true);
        try {
            const datosEnviados = { unidad, fi, ff };
            const response = await myApi.post('/cargasFuel/getGasoMax', datosEnviados);
            if(response.data.success) setData(response.data.data);
            else setData([]);
        } catch(error) {
            console.error('Error fetching fuel loads:', error);
        } finally {
            setLoading(false);
        }
    };

    const updateRow = (rowActualizada) => {
        setData(prev => prev.map(r => r.id === rowActualizada.id ? { ...r, ...rowActualizada } : r));
    };

    useEffect(() => { fetch(); }, []);

    const handleSubmit = async () => {
        let fechainicial = null, fechafinal = null, unidad = null;
        if (startDate && startDate.$d !== 'Invalid Date') fechainicial = startDate.$d.toJSON().substring(0, 10);
        if (endDate && endDate.$d !== 'Invalid Date') fechafinal = endDate.$d.toJSON().substring(0, 10);
        if (unit && unit !== 'undefined' && unit !== '') unidad = unit;
        await fetch(unidad, fechainicial, fechafinal);
    };

    const totalsRow = React.useMemo(() => {
        const sum = (field) => data.reduce((acc, row) => acc + (Number(row[field]) || 0), 0);
        return {
            id: 'totals',
            noEconomico: 'TOTAL',
            isTotal: true,
            consumoPesos: sum('consumoPesos'),
            consumoLitros: sum('consumoLitros'),
        };
    }, [data]);

    const onGridReady = (params) => {
        params.api.sizeColumnsToFit();
    };

    const onFirstDataRendered = (params) => {
        const columns = params.api.getColumns();
        const colsToAutoSize = columns
            .filter(col => {
                const def = col.getColDef();
                return !col.isPinned() && !def.cellRenderer;
            })
            .map(col => col.getColId());
            
        params.api.autoSizeColumns(colsToAutoSize, true);
    };

    const handleExport = () => {
        const columnDefs = gridRef.current.api.getColumnDefs();
        const columnasAExportar = columnDefs
            .filter(col => col.field && !['fotos', 'pc_file', 'actions', 'pdf'].includes(col.field))
            .map(col => col.field);

        gridRef.current.api.exportDataAsCsv({ columnKeys: columnasAExportar });
    };

    const addRow = (rowNueva) => {
        setData(prev => [rowNueva, ...prev]);
    };

    return (
        <>
            {/* Modal Previsores de Imagen/PDF */}
            <Dialog open={open} onClose={handleCloseDialog} maxWidth="md" fullWidth sx={{
                "& .MuiDialogContent-root": { padding: 0 }
            }} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {Titulo}
                </DialogTitle>
                <DialogContent>
                    {isPdf ? (
                        <object data={fileUrl} type="application/pdf" style={{ width: '100%', height: '500px' }}>
                            <p>Tu navegador no soporta la visualización de PDFs. Puedes <a href={fileUrl} target="_blank" rel="noopener noreferrer">ver el PDF aquí</a>.</p>
                        </object>
                    ) : isImage ? (
                        <img src={fileUrl} alt="Imagen" style={{ width: '100%', height: 'auto', objectFit: 'contain' }} />
                    ) : (
                        <p>Este archivo no es un PDF ni una imagen compatible.</p>
                    )}
                </DialogContent>
            </Dialog>

            <Paper
                sx={{
                    p: 2,
                    height: "calc(100vh - 125px)", // ✅ Altura dinámica corregida
                    width: "100%",
                    maxWidth: "100%",
                    display: "flex",
                    flexDirection: "column",
                    boxSizing: "border-box",
                }}
            >
                {/* Formulario / Filtros */}
                <Box sx={{ flexShrink: 0 }}>
                    <form onSubmit={(e) => e.preventDefault()}>
                        <Grid container>
                            <Grid size={{ xs: 12, md: 8 }}>
                                <Typography variant="h4" fontWeight={700}>
                                    Cargas de GasoMax
                                </Typography>
                            </Grid>
                            <Grid size={{ xs: 12, md: 4 }} sx={{ display: 'flex', justifyContent: isNonMobile ? 'flex-end' : 'start' }}>
                                <Button
                                    variant="contained" startIcon={<AddCircleIcon />}
                                    onClick={() => handleOpenModal()}
                                    sx={{ backgroundColor: 'black', marginBottom: 1 }}
                                >
                                    Agregar
                                </Button>
                            </Grid>
                            <Grid container spacing={2} alignItems="center" sx={{ mt: 1 }}>
                                <Grid size={{ xs: 12, sm: 3 }}>
                                    <TextField label="Unidad" variant="outlined" value={unit} onChange={handleChangeUnidad} fullWidth />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 3 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker value={startDate} onChange={handleChangeStartDate} format="MM/DD/YY" label="Fecha Inicial" slotProps={{ textField: { fullWidth: true } }} />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 3 }}>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker value={endDate} onChange={handleChangeEndDate} format="MM/DD/YY" label="Fecha Final" slotProps={{ textField: { fullWidth: true } }} />
                                    </LocalizationProvider>
                                </Grid>
                                <Grid size={{ xs: 12, sm: 3 }}>
                                    <Button
                                        type="button" color="inherit" onClick={handleSubmit} variant="contained"
                                        startIcon={<ManageSearchIcon />} sx={{ color: "primary", fontWeight: "bold" }}
                                    >
                                        Buscar
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </form>
                </Box>

                {/* Lista de Cargas (Grid) */}
                <Box sx={{ flex: 1, minHeight: 0, mt: 1, display: "flex", flexDirection: "column" }}>
                    <Box sx={{ flexShrink: 0, mb: 1 }}>
                        <Button variant="contained" onClick={handleExport} sx={{ width: 'auto', minWidth: 120 }}>
                            Exportar a Excel
                        </Button>
                    </Box>

                    <Box sx={{ flex: 1, minHeight: 0, width: "100%", position: "relative" }}>
                        {loading ? (
                            <Box sx={{ position: "absolute", inset: 0, zIndex: 10, display: "flex", justifyContent: "center", alignItems: "center", background: "rgba(255,255,255,0.6)" }}>
                                <img alt="Cargando..." width="120" height="120" src={img} style={{ borderRadius: "50%" }} />
                            </Box>
                        ) : (
                            <div className="ag-theme-quartz" style={{ height: "100%", width: "100%" }}>
                                <AgGridReact
                                    modules={[AllCommunityModule]} // ✅ Registrado correctamente
                                    ref={gridRef}
                                    rowData={data}
                                    columnDefs={columns}
                                    pagination={true}
                                    pinnedBottomRowData={[totalsRow]}
                                    getRowId={params => params.data.id}
                                    autoSizeStrategy={{
                                        type: 'fitCellContents',
                                        skipHeader: true
                                    }}
                                    onGridReady={onGridReady}
                                    onFirstDataRendered={onFirstDataRendered}
                                /> 
                            </div>
                        )}
                    </Box>
                </Box>
            </Paper>

            <CrearEditarModal
                open={modalOpen} onClose={() => setModalOpen(false)}
                refresh={fetch} carga={selected} isEditing={isEditing}
                onUpdate={updateRow} onCreate={addRow}
            />

            {selectedRow && (
                <GalleryDialog
                    open={openGallery} onClose={handleCloseGallery}
                    fotos={selectedRow?.fotos || []}
                />
            )}
        </>
    );
};

export default CargasGasoMax;